/**
 * Created by Timur on 01.09.2026
 */

const Merge2MissionTutorial = function () {
    return new TutorialScenario(Merge2MissionTutorial.NAME, {
        manual: true,
        listSteps: Merge2MissionTutorial.listSteps,
        isAvailable: function () {
            const mission = cleverapps.missionManager.findRunningMission(Mission.TYPE_MERGE2_MISSION);

            return Boolean(mission && !mission.logic.bubblesStack.isEmpty()
                && !cleverapps.forces.isShown(Forces.MERGE2_MISSION));
        }
    });
};

Merge2MissionTutorial.listSteps = function () {
    return [
        Merge2MissionTutorial.createItemsStep(),
        Merge2MissionTutorial.createStackStep()
    ];
};

Merge2MissionTutorial.createItemsStep = function () {
    return new TutorialStep({
        onStart: function () {
            const createForce = () => {
                const window = cleverapps.focusManager.currentWindow();
                const items = ComponentUtils.findChildByName(window, "itemsStrip");

                return cleverapps.forces.create(ForceView.NO_ELEMENT, Forces.MERGE2_MISSION, {
                    actives: [items],
                    highlights: [items],
                    importantNodes: [items]
                });
            };

            this.force = createForce();

            if (!this.force) {
                this.finish();
                return;
            }

            cleverapps.tutorial.on("onResize", () => {
                this.force.close();
                this.force = createForce();
            }, this);

            cleverapps.tutorial.on("touchInShadow", this.finish.bind(this), this);
        },

        onFinish: function () {
            cleverapps.tutorial.startNextStep();
        }
    });
};

Merge2MissionTutorial.createStackStep = function () {
    return new TutorialStep({
        onStart: function () {
            const createForce = () => {
                const window = cleverapps.focusManager.currentWindow();
                const stack = ComponentUtils.findChildByName(window, "bubblesStack");

                return cleverapps.forces.create(stack, {
                    text: "Merge2MissionTutorial.stack",
                    pointer: true
                }, {
                    actives: [stack],
                    highlights: [window],
                    importantNodes: [stack]
                });
            };

            this.force = createForce();

            if (!this.force) {
                this.finish();
                return;
            }

            cleverapps.tutorial.on("onResize", () => {
                this.force.close();
                this.force = createForce();
            }, this);

            cleverapps.tutorial.on("merge2MissionBubbleTapped", this.finish.bind(this), this);
        },

        onFinish: function () {
            cleverapps.tutorial.startNextStep();
            cleverapps.focusManager.setEventNodes([cleverapps.focusManager.currentWindow()]);
        }
    });
};

Merge2MissionTutorial.NAME = "merge2_mission_tutorial";
